var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"shadow-color"},[_c('div',{staticClass:"title"},[_vm._v("阴影颜色")]),_vm._v(" "),_c('div',{staticClass:"btn",style:({backgroundColor: _vm.color}),on:{"click":function($event){$event.stopPropagation();return _vm.clickColor.apply(null, arguments)}}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c4a99f3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/subtitle/subtitlePanel/shadowColor.vue
// module id = null
// module chunks = 